import React from 'react'
import PhoneNumberFormat from '../PhoneNumberFormat';

import styles from './styles.module.scss';
import ValidatedTextInput from '../ValidatedTextInput';

const PhoneInput = (props) => {
  const {
    value,
    onChange,
    onKeyDown,
    style = {},
    fullWidth = false,
    disabled = false,
    autoFocus = false,
    InputProps: inputPropsOverride = {},
    inputTestId,
    inputProps: inputPropsProp,
    ...rest
  } = props;

  const baseInputProps = {
    inputComponent: PhoneNumberFormat,
    startAdornment: (<div className={styles.prefix}>{'+61'}</div>),
    name: 'phoneInput',
    ...inputPropsOverride,
  };

  const mergedInputProps = {
    ...(inputPropsProp ?? {}),
  };
  if (inputTestId && mergedInputProps['data-testid'] === undefined) {
    mergedInputProps['data-testid'] = inputTestId;
  }
  const finalInputProps = Object.keys(mergedInputProps).length ? mergedInputProps : undefined;

  return (
    <ValidatedTextInput
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      fullWidth={fullWidth}
      style={style}
      disabled={disabled}
      variant="outlined"
      name="phoneInput"
      autoFocus={autoFocus}
      {...rest}
      validators={['minStringLength:1', 'matchRegexp:^0?\\({0,1}(4|5){1}\\){0,1}( |-){0,1}[0-9]{2}(\\|){0,1}[0-9]{2}(\\|){0,1}[0-9]{1}( |-){0,1}[0-9]{3}$']}
      errorMessages={['Phone number is required', 'Please enter a valid mobile number']}
      InputProps={baseInputProps}
      inputProps={finalInputProps}
    />
  );
};

export default PhoneInput
